/**
 * base: 390px
 * lg: 768px
 * xl: 1024px
 * xxl: 1280px
 */
import { css } from '@/styled-system/css';

const infoRow = css.raw({
  display: 'flex',
  flexDirection: { base: 'column', lg: 'row', xl: 'column' },
  alignItems: { base: 'flex-start', lg: 'center', xl: 'flex-start' },
  justifyContent: 'space-between',
  // oxlint-disable-next-line constellation/prefer-semantic-tokens -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
  gap: '{spacing.400}',
  padding: '{spacing.zero} {spacing.400}',
  width: '100%',
});

const infoCol = css.raw({
  display: 'flex',
  flexDirection: { base: 'row' },
  flex: 1,
  alignItems: { base: 'center' },
  // oxlint-disable-next-line constellation/prefer-semantic-tokens -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
  gap: '{spacing.200}',
});

const columnEmailBox = css.raw({
  display: 'flex',
  flexDirection: 'row',
  // oxlint-disable-next-line constellation/prefer-semantic-tokens -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
  columnGap: '{spacing.200}',
});

const columnContentMaxWidth = css.raw({
  // maxWidth: { base: '100%', lg: '124px' },
  maxWidth: { base: '100%' },
});

const iconRowItem = css.raw({
  // oxlint-disable-next-line constellation/prefer-semantic-tokens -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
  color: '{colors.gray.400}',
});

const sectionTitleRow = css.raw({
  // oxlint-disable-next-line constellation/prefer-semantic-tokens -- ESLint's pandaLint set this warn-only; oxlint's oxlintPandaLint sets it error, no code change
  marginBottom: '{spacing.400}',
});

export { columnContentMaxWidth, columnEmailBox, infoRow, infoCol, iconRowItem, sectionTitleRow };
